import { useIsInDEOpenBankingCopyTest } from '../../../../hooks/useIsInDEOpenBankingCopyTest';

export const LinkOpenBankingDocumentRequirementContentDE = () => {
  const { isIncludedInOBCopyTest } = useIsInDEOpenBankingCopyTest();

  if (isIncludedInOBCopyTest) {
    return <IncludeBranchCopy />;
  }

  return <ExcludeBranchCopy />;
};

const IncludeBranchCopy = () => {
  return (
    <div>
      <ul>
        <li>
          Wir benötigen die Transaktionshistorie für unsere Kreditentscheidung,
          um Ihnen das beste Angebot machen zu können.
        </li>
        <li>
          Bitte teilen Sie alle Kontoauszüge, die mehr als 10% Ihres
          Gesamtumsatzes ausmachen.
        </li>
      </ul>
    </div>
  );
};

const ExcludeBranchCopy = () => {
  return (
    <div>
      <h4>Mein Bankkonto verknüpfen</h4>
      <ul>
        <li>
          Open Banking ist ein sicherer Weg, Ihre Kontodaten zu teilen, ohne Ihr
          Passwort weiterzugeben.{' '}
          <a href="https://www.iwoca.de/kredit/open-banking">Mehr erfahren</a>
        </li>
        <li>
          Verknüpfen Sie alle Konten, die mehr als 10% Ihres Gesamtumsatzes
          ausmachen.
        </li>
      </ul>
    </div>
  );
};
